<template>
  <div id="AddUsdaIngredient" class="container max-w-4xl mx-auto pt-20 pb-20 px6">

    <div class="text-gray-900 text-xl">{{ mealPlan.name }} Meal Plan Nutrition</div>
    <div class="bg-sky-500 w-full h-1"></div>

    <div v-if="mealPlan.recipes.length > 0" class="pt-5 pb-5">
      <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                      <th scope="col" class="px-6 py-3">
                          {{ mealPlan.name }} Meal Plan
                      </th>
                      <th scope="col" class="px-6 py-3" v-for="recipe in mealPlan.recipes" :key="recipeHeaderKey(recipe)">
                          {{ recipe.name }}
                      </th>
                  </tr>
              </thead>
              <tbody>
                  <tr class="bg-white border-b dark:bg-gray-900 dark:border-gray-700">
                    <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">100% of Meal Plan</th>
                    <td class="px-6 py-4" v-for="recipe in mealPlan.recipes" :key="recipePercentKey(recipe)">
                      {{ percentOfMealPlan() }}% of Meal Plan
                    </td>
                  </tr>
                  <tr class="border-b bg-gray-50 dark:bg-gray-800 dark:border-gray-700">
                    <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                      {{ mealPlan.nutrition_breakdown.total_qty }}{{ mealPlan.nutrition_breakdown.total_unit_type }}
                    </th>
                    <td class="px-6 py-4" v-for="recipe in mealPlan.recipes" :key="recipeTotalKey(recipe)">
                      {{ recipe.nutrition_breakdown.total_qty }}{{ recipe.nutrition_breakdown.total_unit_type }}
                    </td>
                  </tr>
                  <tr v-for="(nutrient, index) in mealPlan.nutrition_breakdown.nutrients" :key="nutrient.id"
                    :class="index % 2 == 0 ? 'border-b bg-gray-50 dark:bg-gray-800 dark:border-gray-700' : 'bg-white border-b dark:bg-gray-900 dark:border-gray-700'">
                      <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        {{ nutrient.name }} {{ nutrient.amount.qty }}{{ nutrient.amount.unit_type }}
                      </th>
                      <td class="px-6 py-4" v-for="recipe in mealPlan.recipes" :key="recipeBodyKey(recipe)">
                        {{ nutrient.name }} {{ recipe.nutrition_breakdown.nutrients[index].amount.qty }}{{ recipe.nutrition_breakdown.nutrients[index].amount.unit_type }}
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
    </div>


  </div>
</template>

<script setup>
  import { onMounted, ref } from 'vue'
  import { useRoute } from 'vue-router'
  import axios from 'axios'

  const route = useRoute()

  let mealPlan = ref({recipes: []})
  let errors = ref([])

  onMounted(async () => {
      await getMealPlan()
  })

  const getMealPlan = async () => {
    try {
      let res = await axios.get('meal-plans/' + route.params.id + '?include_nutrition_breakdown=true&include_recipes_nutrition_breakdown=true')
      mealPlan.value = res.data.meal_plan
      console.log(res.data)
    } catch (err) {
      errors.value = err.response.data.errors
    }
  }

  const percentOfMealPlan = () => {
    return Math.round((100 / mealPlan.value.recipes.length) * 100) / 100
  }

  const recipeHeaderKey = (recipe)  => {
    return 'head-'+recipe.id
  }

  const recipePercentKey = (recipe)  => {
    return 'percent-'+recipe.id
  }

  const recipeTotalKey = (recipe)  => {
    return 'total-'+recipe.id
  }
  
  const recipeBodyKey = (recipe)  => {
    return 'body-'+recipe.id
  }
</script>
